export default __webpack_public_path__ + "static/media/cover.efe8ba2d.png";